import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";
import { ReverseChargeSetting } from "@/module/Form/ReverseCharge/ReverseChargeSetting";

export default class IsTaxExempt {
  private foreignCustomerDeterminer: ForeignCustomerDeterminer;

  constructor(foreignCustomerDeterminer: ForeignCustomerDeterminer) {
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
  }

  isTaxExempt(
    vatPayer: boolean,
    country: string | null,
    shippingCountry: string | null,
    reverseChargeSetting: ReverseChargeSetting,
  ) {
    if (
      !vatPayer ||
      !this.foreignCustomerDeterminer.isForeignCustomer(country)
    ) {
      return false;
    }

    if (this.foreignCustomerDeterminer.isCountryInEu(country)) {
      return false;
    }

    if (this.foreignCustomerDeterminer.isCountryInEu(shippingCountry)) {
      return false;
    }

    return reverseChargeSetting !== ReverseChargeSetting.DISABLED;
  }
}
